(function () {
  'use strict';
  if (window.__fizzyCustomerStories) return;
  window.__fizzyCustomerStories = true;
  var instances = new Map();

  function init(root) {
    if (instances.has(root)) return;
    var rail = root.querySelector('[data-fcs-rail]');
    if (!rail) return;
    var cards = Array.from(rail.children);
    var nav = root.querySelector('[data-fcs-nav]');
    var prev = root.querySelector('[data-fcs-prev]');
    var next = root.querySelector('[data-fcs-next]');
    var player = root.querySelector('[data-fcs-player]');
    var video = root.querySelector('[data-fcs-video]');
    var title = root.querySelector('[data-fcs-player-title]');
    var close = root.querySelector('[data-fcs-close]');
    var status = root.querySelector('[data-fcs-status]');
    var fallback = root.querySelector('[data-fcs-fallback]');
    var preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    var opener = null;
    var previews = Array.from(root.querySelectorAll('[data-fcs-preview]'));
    var previewObserver = null;
    // Sam 2026-10-09: "the video should play in the card" and "render in the entire parent container".
    // Watch now plays the clip in place, filling the whole card, with native controls; the dialog
    // player remains only as a fallback.
    var inlineObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) return;
        var clip = entry.target.querySelector('video[data-fcs-inline]');
        if (clip && !clip.paused) clip.pause();
      });
    }, { threshold: 0.25 }) : null;

    // Only a clip without a configured portrait needs metadata for its thumbnail.
    // No autoplay, idle download or full-player source is attached at page load.
    function attachPreview(preview) {
      if (preview.getAttribute('src')) return;
      preview.preload = 'metadata';
      preview.src = preview.dataset.fcsPreview.split('#')[0] + '#t=0.1';
    }
    if (previews.length && 'IntersectionObserver' in window) {
      previewObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          attachPreview(entry.target);
          previewObserver.unobserve(entry.target);
        });
      }, { rootMargin: '300px 0px', threshold: 0.01 });
      previews.forEach(function (preview) { previewObserver.observe(preview); });
    }

    function update() {
      var max = rail.scrollWidth - rail.clientWidth;
      var overflow = max > 2;
      nav.hidden = !overflow;
      if (overflow) rail.setAttribute('tabindex', '0');
      else rail.removeAttribute('tabindex');
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max - 2;
    }
    function move(direction) {
      var step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : rail.clientWidth;
      rail.scrollBy({ left: direction * step, behavior: preference.matches ? 'instant' : 'smooth' });
    }
    function onPrev() { move(-1); }
    function onNext() { move(1); }
    function onKey(event) {
      if (event.target !== rail) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        move(event.key === 'ArrowLeft' ? -1 : 1);
      }
    }
    function requestClose() {
      if (!player.open) return;
      video.pause();
      window.fizzyPopupMotion.close(player);
    }
    function onCancel(event) { event.preventDefault(); requestClose(); }
    function onBackdrop(event) {
      if (event.target !== player) return;
      var rect = player.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) requestClose();
    }
    function onClose() {
      video.pause();
      video.removeAttribute('src');
      video.load();
      status.hidden = true;
      if (opener && opener.isConnected) opener.focus({ preventScroll: true });
      opener = null;
    }
    function onMetadata() {
      if (video.videoWidth && video.videoHeight) video.style.setProperty('--fcs-video-ratio', video.videoWidth + '/' + video.videoHeight);
    }
    function onError() { if (player.open) status.hidden = false; }
    function onPlay() {
      document.querySelectorAll('video').forEach(function (other) {
        if (other !== video && !other.muted && !other.paused) other.pause();
      });
      status.hidden = true;
    }
    function pauseOthers(event) {
      document.querySelectorAll('video').forEach(function (other) {
        if (other !== event.target && !other.muted && !other.paused) other.pause();
      });
    }
    function stopInline(card, restoreFocus) {
      var clip = card && card.querySelector('video[data-fcs-inline]');
      if (!clip) return;
      clip.__fcsStopping = true;
      clip.pause();
      clip.removeAttribute('src');
      clip.load();
      clip.remove();
      if (inlineObserver) inlineObserver.unobserve(card);
      card.classList.remove('is-playing');
      var link = card.querySelector('[data-fcs-watch]');
      // The button is hidden while the clip plays; return focus to it, retrying once styles settle.
      if (restoreFocus && link) {
        link.focus({ preventScroll: true });
        if (document.activeElement !== link) setTimeout(function () { link.focus({ preventScroll: true }); }, 60);
      }
    }
    function inlineFailed(card, link) {
      stopInline(card, false);
      if (!card || card.querySelector('.fcs-inline-status')) return;
      var note = document.createElement('p');
      note.className = 'fcs-inline-status';
      note.setAttribute('role', 'status');
      note.append('We couldn’t play this video. ');
      var open = document.createElement('a');
      open.href = link.href;
      open.target = '_blank';
      open.rel = 'noopener';
      open.textContent = 'Open the video';
      note.append(open, '.');
      card.appendChild(note);
    }
    function playInline(link) {
      var media = link.closest('.fcs-open-media');
      var card = link.closest('.fcs__card');
      if (!media || !card) return false;
      document.querySelectorAll('.fcs__card.is-playing').forEach(function (other) {
        if (other !== card) stopInline(other, false);
      });
      var stale = card.querySelector('.fcs-inline-status');
      if (stale) stale.remove();
      var clip = card.querySelector('video[data-fcs-inline]');
      if (!clip) {
        clip = document.createElement('video');
        clip.setAttribute('data-fcs-inline', '');
        clip.className = 'fcs-inline-video';
        clip.controls = true;
        clip.playsInline = true;
        clip.setAttribute('playsinline', '');
        clip.preload = 'auto';
        if (link.dataset.fcsPoster) clip.poster = link.dataset.fcsPoster;
        clip.setAttribute('aria-label', (link.dataset.fcsAuthor || 'Customer') + '’s story');
        clip.addEventListener('play', pauseOthers);
        // Sam 2026-10-09: pausing returns the card to its photo and words; Watch resumes from there.
        clip.addEventListener('pause', function () {
          if (clip.__fcsStopping || clip.ended) return;
          link.dataset.fcsTime = String(clip.currentTime);
          stopInline(card, card.contains(document.activeElement));
        });
        clip.addEventListener('ended', function () {
          delete link.dataset.fcsTime;
          stopInline(card, true);
        });
        if (link.dataset.fcsTime) {
          clip.addEventListener('loadedmetadata', function () {
            var resume = parseFloat(link.dataset.fcsTime);
            if (resume > 0 && resume < clip.duration - 0.5) clip.currentTime = resume;
          }, { once: true });
        }
        clip.addEventListener('error', function () { inlineFailed(card, link); });
        clip.addEventListener('keydown', function (event) {
          if (event.key === 'Escape') { event.preventDefault(); stopInline(card, true); }
        });
        clip.src = link.href;
        card.appendChild(clip);
        if (inlineObserver) inlineObserver.observe(card);
      }
      card.classList.add('is-playing');
      clip.focus({ preventScroll: true });
      var promise = clip.play();
      if (promise) promise.catch(function () {
        // Native controls stay available if the browser wants another tap.
        if (clip.error) inlineFailed(card, link);
      });
      return true;
    }
    function onWatch(event) {
      var link = event.target.closest('[data-fcs-watch]');
      if (!link || !root.contains(link) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
      if (playInline(link)) { event.preventDefault(); return; }
      if (typeof player.showModal !== 'function') return;
      event.preventDefault();
      opener = link;
      title.textContent = link.dataset.fcsAuthor + '’s story';
      video.setAttribute('aria-label', title.textContent);
      video.style.removeProperty('--fcs-video-ratio');
      if (link.dataset.fcsPoster) video.poster = link.dataset.fcsPoster;
      else video.removeAttribute('poster');
      video.src = link.href;
      fallback.href = link.href;
      status.hidden = true;
      window.fizzyPopupMotion.open(player);
      var promise = video.play();
      if (promise) promise.catch(function () {
        // Native controls remain available if playback needs another user gesture.
        if (video.error) onError();
      });
    }
    root.classList.add('is-ready');
    root.addEventListener('click', onWatch);
    prev.addEventListener('click', onPrev);
    next.addEventListener('click', onNext);
    rail.addEventListener('scroll', update, { passive: true });
    rail.addEventListener('keydown', onKey);
    close.addEventListener('click', requestClose);
    player.addEventListener('cancel', onCancel);
    player.addEventListener('click', onBackdrop);
    player.addEventListener('close', onClose);
    video.addEventListener('error', onError);
    video.addEventListener('play', onPlay);
    video.addEventListener('loadedmetadata', onMetadata);
    var observer = new ResizeObserver(update);
    observer.observe(rail);
    update();
    instances.set(root, function () {
      observer.disconnect();
      if (previewObserver) previewObserver.disconnect();
      if (inlineObserver) inlineObserver.disconnect();
      root.querySelectorAll('.fcs__card.is-playing').forEach(function (card) { stopInline(card, false); });
      if (player.open) player.close();
      onClose();
      root.removeEventListener('click', onWatch);
      prev.removeEventListener('click', onPrev);
      next.removeEventListener('click', onNext);
      rail.removeEventListener('scroll', update);
      rail.removeEventListener('keydown', onKey);
      close.removeEventListener('click', requestClose);
      player.removeEventListener('cancel', onCancel);
      player.removeEventListener('click', onBackdrop);
      player.removeEventListener('close', onClose);
      video.removeEventListener('error', onError);
      video.removeEventListener('play', onPlay);
      video.removeEventListener('loadedmetadata', onMetadata);
    });
  }
  function scan(scope) {
    if (scope.matches && scope.matches('[data-fcs]')) init(scope);
    scope.querySelectorAll('[data-fcs]').forEach(init);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (dispose, root) {
      if (event.target === root || event.target.contains(root)) { dispose(); instances.delete(root); }
    });
  });
})();
